<template>
  <div id="product-page">
    <div class="grid-row">
      
      <div class="c-6 c-lg-5 c-md-6 c-sm-12 c-xs-12">
        <div class="product-img-container">
          <div class="product-division">
            <div class="division-img" v-for="(logo, index) in getDivisionLogo" :key="index">
              <img :src="logo" />
            </div>
          </div>
          <div class="product-img">
            <div class="etiquette">
              <div v-if="tcoll === 'F' && tcatgen === 'OFFRE'">
                <div class="limited-stock">
                  <span>{{$_('limited_stock').toUpperCase()}}</span>
                </div>
                <div class="special-offer">
                  <span>{{$_('special_offer').toUpperCase()}}</span>
                </div>
              </div>
              <div v-else-if="tcoll === 'F'">
                <div class="end-fo-series">
                  <span>{{$_('end_of_series').toUpperCase()}}</span>
                </div>
                <div class="limited-stock">
                  <span>{{$_('limited_stock').toUpperCase()}}</span>
                </div>
              </div>
              <div v-else-if="tcatgen === 'OFFRE'">
                <div class="special-offer">
                  <span>{{$_('special_offer').toUpperCase()}}</span>
                </div>
                <div class="limited-stock">
                  <span>{{$_('limited_stock').toUpperCase()}}</span>
                </div>
              </div>
            </div>
            <LightBox
              :aImage="product_img"
              :fImageIntrouvable="fImageIntrouvable"
            ></LightBox>  
          </div>
        </div>
      </div>

      <div class="c-6 c-lg-5 c-md-6 c-sm-12 c-xs-12 p-0">
        <h1>{{$_('reference').toUpperCase()}} {{this.$route.query.p}} : {{this.$store.getters['produit/get_desc_prod']}}</h1>
        <p><small>{{$_('composition')}} : {{getCompo}}</small></p>
        <article>
          <p>{{this.$store.getters['produit/get_descm_court']}}</p>
        </article>
        <h3>{{$_('configure_ribbon')}}</h3>
        <div class="content">
          <div class="product-configurator">
            <ProductConfigurator />
          </div>
          <div class="configurator-bottom">
            <div class="stock-container">
              <Stock :reset_qte="reset_qte" />
            </div>
            <div class="price-container">
              <Price />
            </div>
          </div>
          <div class="product-btn-container">
            <div class="product-btn-container">
                <div class="add-to-cart-container">
                  <span v-if="displayButton" @click="addToCart()" :class="{'animate': animate_button}" class="btn add-to-cart">
                    <span class="btn-title">{{$_('add_to_cart')}}</span>
                    <span class="check-mark"><i class="material-icons">check</i></span>
                  </span>   
                  <span v-if="collection_card_price > 0" @click="addToCart('collection')" :class="{'animate': animate_collection_button}" class="btn light add-to-cart">
                    <span class="btn-title">{{$_('add_collection_card')}} ({{collection_card_price}} {{collection_card_dev}})</span>
                    <span class="check-mark"><i class="material-icons">check</i></span>
                  </span>
                  <span v-else>{{$_('collection_card_contact')}}</span> 
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="c-12 c-lg-12 c-md-12 c-sm-12 c-xs-12">
      <div class="more-section">
        <h2>{{$_('further_information')}}</h2>
        <div class="more-description">

          <pre>
            <p v-html="vText(this.$store.getters['produit/get_descm_long'])"></p>
            </pre>

        </div>
        <div class="document-download-section">
          <a class="btn-download" @click="vDownloadFicheTechnique($route.query.p)">{{$_('technical_sheet').toUpperCase()}}</a>
          <a class="btn-download" download :href="`${base_url}static/produits/${this.$route.query.p}/carte/cc-${this.$route.query.p}.pdf`">{{$_('collection_card').toUpperCase()}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LightBox from '@/common/components/widget/LightBox'
import ProductConfigurator from '@/modules/produit/components/ProductConfigurator';
import Stock from "@/modules/produit/components/Stock";
import Price from "@/modules/produit/components/Price";

import productService from "@/modules/produit/services/productService";
import cartService from "@/modules/panier/services/cartService";

export default {
  components: {
    LightBox,
    Stock,
    Price,
    ProductConfigurator
  },
  data() {
    return {
      product_img: [],
      base_url: process.env.VUE_APP_API_URL,
      tcatgen: '',
      tcoll: '',
      animate_button: false,
      animate_collection_button: false,
      collection_card_price: 0,
      collection_card_dev: '',
      reset_qte: false,
    };
  },
  async created() {
    this.$store.dispatch('produit/SELECT', {key: 'fmod', value: this.$route.query.p});
    this.tcoll = this.$route.query.tcoll;
    this.tcatgen =  this.$route.query.tcatgen;

    for (var i = 1; i <= 10; i++) {
      const imgUrl = await this.sGetImageProduct(this.$route.query.p, i);
      if (imgUrl) { // Ne ajouter que les images qui existent
        this.product_img.push(imgUrl);
      }
    }

    window.scrollTo(0,0);
  },
  destroyed() {
    this.product_img.forEach(url => URL.revokeObjectURL(url));
    this.$store.dispatch('produit/RESET_PRODUCT_PAGE');
  },
  computed: {
    displayButton() {
      if(
        (this.$store.getters['produit/get_ftail1'] !== '' &&
        this.$store.getters['produit/get_ftail2'] !== '' &&
        this.$store.getters['produit/get_opt'] !== '' &&
        this.$store.getters['produit/get_fcol'] !== '' &&
        this.$store.getters['produit/get_fmarq'] !== '' &&
        this.$store.getters['produit/get_fqte'] >= 1 &&
        this.$store.getters['produit/get_total_price'] !== 0) &&
        this.$store.getters['produit/get_display_button_add_to_cart'] === true
      ) {
        return true;
      }
      return false;
    },
    getCompo() {
      return this.$store.getters['produit/get_compo'];
    },
    getDivisionLogo() {
      return this.$store.getters['produit/get_division_img'];
    },
    getCard() {
      return this.$store.getters['produit/get_collection_card'];
    }
  },
  methods: {
    vText(text) {
      return text.replace(/\n/g, '<br />')
    },
    fImageIntrouvable(event) {
      // URL de l'image par défaut
      const fallback = `${process.env.VUE_APP_API_URL}static/vignettes/non-disponible.jpg`;

      // Stoppe si l'image a déjà déclenché une erreur
      if (event.target.dataset.erreur === "true") return;

      // Marque l'image comme "en erreur" pour éviter les boucles
      event.target.dataset.erreur = "true";

      // On utilise directement l'image par défaut pour éviter les boucles
      event.target.src = fallback;
    },
    async sGetImageProduct(tmod,i) {
      try {
        const response = await productService.getFileProductImage(tmod, `p${i}-${tmod}.jpg`);

        const blob = response.data; // <-- ici le vrai blob devrait arriver

        if (!(blob instanceof Blob)) {
          throw new TypeError("Le fichier récupéré n'est pas un Blob");
        }

        return URL.createObjectURL(blob);
      
      } catch {
        // Retourner null au lieu de l'URL directe pour indiquer qu'il n'y a pas d'image
        console.log("fail");
        return `${process.env.VUE_APP_API_URL}static/vignettes/non-disponible.jpg`;
      }
    },
    vDownloadFicheTechnique(fmod) {
      productService.getFicheTechnique(fmod).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'fiche-technique.pdf');
        document.body.appendChild(link);
        link.click();
      })
    },
    addToCart(type) {

       let params = Object;

      if(type === 'collection') {

        params = {
          p_mod: this.$store.getters['produit/get_collection_card'].TMOD_K,
          p_opt: this.$store.getters['produit/get_collection_card'].TOPT_K,
          p_tail1: this.$store.getters['produit/get_collection_card'].TTAIL1_K,
          p_tail2: this.$store.getters['produit/get_collection_card'].TTAIL2_K,
          p_col: this.$store.getters['produit/get_collection_card'].TCOL_K,
          p_marq: this.$store.getters['produit/get_collection_card'].TMARQ_K,
          p_qte: 1,
          pcpromo: '',
          p_sup: 0
        };
      } else {
        params = {
          p_mod: this.$store.getters['produit/get_fmod'],
          p_opt: this.$store.getters['produit/get_fopt'],
          p_tail1: this.$store.getters['produit/get_ftail1'],
          p_tail2: this.$store.getters['produit/get_ftail2'],
          p_col: this.$store.getters['produit/get_fcol'],
          p_marq: this.$store.getters['produit/get_fmarq'],
          p_qte: this.$store.getters['produit/get_fqte'],
          pcpromo: '',
          p_sup: 0
        };
      }

      cartService.addToCart(params)
      .then(res => {

        if(res.data !== undefined) {

          this.$store.dispatch('panier/SET', {key: 'pnbon', value: res.data.PNBON_OUT});

          if(type === 'collection') {
            this.animate_collection_button = true;
          } else {
            this.animate_button = true;
          }
          
          setTimeout(() => {
            this.animate_button = false;
            this.animate_collection_button = false;
          }, 2000);

          this.reset_qte = true;

          setTimeout(() => {
            this.reset_qte = false
          }, 1000);

          this.$store.dispatch('panier/SET', {key: 'reload_cart', value: true});
        }
      })
    }
  },
  watch: {
    displayButton(val) {
      if(val) {
        productService.getPriceInfo({
          pmod: this.$store.getters['produit/get_collection_card'].TMOD_K,
          popt: this.$store.getters['produit/get_collection_card'].TOPT_K,
          ptail1: this.$store.getters['produit/get_collection_card'].TTAIL1_K,
          ptail2: this.$store.getters['produit/get_collection_card'].TTAIL2_K,
          pcol: this.$store.getters['produit/get_collection_card'].TCOL_K,
          pmarq: this.$store.getters['produit/get_collection_card'].TMARQ_K,
          pqte: 1
        })
        .then(res => {
          if(res.data !== null) {
            this.collection_card_price = res.data.PPRIX;
            this.collection_card_dev = res.data.PCDEV;
          }
        })
      }
    },
    getCard() {
      productService.getPriceInfo({
        pmod: this.$store.getters['produit/get_collection_card'].TMOD_K,
        popt: this.$store.getters['produit/get_collection_card'].TOPT_K,
        ptail1: this.$store.getters['produit/get_collection_card'].TTAIL1_K,
        ptail2: this.$store.getters['produit/get_collection_card'].TTAIL2_K,
        pcol: this.$store.getters['produit/get_collection_card'].TCOL_K,
        pmarq: this.$store.getters['produit/get_collection_card'].TMARQ_K,
        pqte: 1
      })
      .then(res => {
        if(res.data !== null) {
          this.collection_card_price = res.data.PPRIX;
          this.collection_card_dev = res.data.PCDEV;
        }
      })
    }
  },
}
</script>

<style scoped>
h1 {
  color: #2a2a2a;
}
h3 {
  margin-top: 20px;
  margin-bottom: 20px;
  text-transform: uppercase;
}
.content {
  border: solid #f1f1f1 1px;
  padding: 20px;
  font-size: 13px;
}
.more-section {
  padding: 30px 25px;
}
.more-description p {
  font-size: var(--fz-md);
  color: #8B8B8B;
}
.document-download-section a{
  margin-right: 20px;
}
.end-fo-series {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgb(240, 130, 12);
  padding: 6px 10px;
  display: flex;
}
.end-fo-series span {
  font-size: .6rem;
  color: #fff;
}
.special-offer {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #F00C33;
  padding: 6px 10px;
  display: flex;
}
.special-offer span {
  font-size: .6rem;
  color: #fff;
}
.limited-stock {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #F00C33;
  padding: 6px 10px;
  display: flex;
}
.limited-stock span {
  font-size: .6rem;
  color: #fff;
}
.etiquette {
  max-width: 380px;
  margin: auto;
  position: relative;
  z-index: 1;
  top: 10px;
}
.more-description p {
  white-space: normal;
}
article p {
  color: #8b8b8b;
  font-size: var(--fz-md);
}
.configurator-bottom {
  border-top: solid 1px #f1f1f1;
  display: flex;
  justify-content: space-between;
}
.price-container {
  padding: 15px;
  display: flex;
  align-items: center;
}
.btn.add-to-cart {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-right: 15px;
}
.btn.add-to-cart .check-mark {
  position: absolute;
  transform:translateX(-200px);
}
.btn.add-to-cart.animate .btn-title {
  position: relative;
  visibility: hidden;
}
.btn.add-to-cart.animate .check-mark{
  animation: check-slide 1.5s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}
.product-img-container {
  display: flex;
  justify-content: center;
}
.product-division {
  padding: 7px 0px;
}
@keyframes check-slide {
  50% {
    transform:translateX(0);
  }
  70% {
    transform:translateX(0);
  }
  100% {
    transform:translateX(200px);
  }
}

@media (min-width: 768px) {
    .content {
      position: relative;
    }
}


</style>